//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Paginate from 'vuejs-paginate';
import TabelaGenerica from '../../../../../shared-components/generico/TabelaGenerica';
import mdAutocomplete from '../../../../../shared-components/autocomplete/mdAutocomplete';
import basePath from '../../../../../common/functions/api-resource';
import FiltrosDash from './FiltrosDash';
import {
     convertFloatToMoney,
     copyObject,
} from '../../../../../common/functions/helpers';
import { prepareResponseData } from '../../../../../common/functions/http';

export default {
  extends: TabelaGenerica,
  props: {
    contrato: Object,
    carregando: Boolean,
    paginas: Number,
  },
  data() {
    return {
      reivindicacaoResources: this.$api.reivindicacao(this.$resource),
      tipoInvestimentoResources: this.$api.tipoInvestimento(this.$resource),
      dashboardNegociacaoResources: this.$api.dashboardNegociacao(this.$resource),
      clienteResources: this.$api.cliente(this.$resource),
      produtoResources: this.$api.produto(this.$resource),
      canPost: false,
      somenteLeitura: false,
      nomContato: '',
      hasFilter: false,
      indexPagina: 0,
      itemSelecionado: null,
      justificativa: '',
      objetosSelecionados: [],
      justificativaGrid: null,
      filtro: {
        solicitante: '',
        tipoAcordo: '',
        status: 'APROVADO',
        tipoLinhaOrcamento: '',
        marca: '',
        linhaProduto: '',
        familia: '',
        produto: '',
        cliente: '',
        meuPassoPendente: true,
      },
      filtroCopy: {},
      statusNegociacoes: [
        { status: 'EM_CADASTRO', descricao: this.$t('status_entidade.em_cadastro') }, { status: 'AGUARDANDO_APROVACAO', descricao: this.$t('status_entidade.aguardando_aprovacao') },
        { status: 'APROVADO', descricao: this.$tc('status_entidade.aprovado', 1) }, { status: 'REPROVADO', descricao: this.$tc('status_entidade.reprovado', 1) },
        { status: 'ENCERRADO', descricao: this.$t('label.encerrado') }, { status: 'CANCELADO', descricao: this.$t('label.cancelado') },
        { status: 'EM_ANALISE', descricao: this.$t('status_entidade.em_analise') }],
    };
  },
  computed: {
    hasSingleRowSelected() {
      return this.selected && this.selected.length === 1;
    },
  },
  components: {
    mdAutocomplete,
    FiltrosDash,
    Paginate,
  },
  methods: {
    prepareResponseData,
    toggleSelecaoGeral(selecao) {
      this.filteredList.forEach((item) => {
        item.selecionado = selecao;
      });
      this.objetosSelecionados = !selecao ? [] : ([...this.filteredList]);
    },
    toggleSelecaoUnica(row) {
      setTimeout(() => {
        const selecao = row.selecionado;
        if (selecao) {
          this.objetosSelecionados.push(row);
          return;
        }

        let indexO = null;
        this.objetosSelecionados.forEach((obj, index) => {
          if (obj.idWorkflow === row.idWorkflow) {
            indexO = index;
          }
        });
        this.objetosSelecionados.splice(indexO, 1);
      });
    },
    clickOnRow(row = null, index) {
      this.$emit('ACORDOTABELA_CLICK_LINHA', this.contrato, row, index);
    },
    defaultClose() {
      this.requestCleanFiltro();
      this.getLimpaReferenciasJustificativa();
      this.$refs.modal.close();
    },
    getLimpaReferenciasJustificativa() {
      // this.$refs.inputJustificativaAnalise.hasValue = false;
      // this.$refs.inputJustificativaAnalise.inputLength = 0;
      // this.$refs.inputJustificativaAprovar.hasValue = false;
      // this.$refs.inputJustificativaAprovar.inputLength = 0;
      // this.$refs.inputJustificativaReprovar.hasValue = false;
      // this.$refs.inputJustificativaReprovar.inputLength = 0;
      this.$forceUpdate();
    },
    requestFecharModaisDefault() {
      this.$refs.modalReprovar.close();
      this.$refs.modalAprovar.close();
      this.$refs.modalComentario.close();
      this.justificativa = '';
    },
    requestBuscarMotivoLog(row) {
      this.reivindicacaoResources.justificativa({ idReivindicacao: row.id })
        .then((response) => {
          const motivo = response.data.justificativa;
          this.justificativaGrid = motivo.justificativa || motivo;
          this.$refs.modalComentario.open();
        })
        .catch((err) => {
          this.$error(this, err);
          // this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    filtrarModal(filtro) {
      this.filtro = copyObject(filtro);
      this.requestBuscarApuracoesFilter();
    },
    getMoney(str) {
      str = convertFloatToMoney(String(str));
      str = str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const money = str.split('.');
      return `${money[0].replace(/,/g, '.')},${money[1]}`;
    },
    requestCleanFiltro() {
      this.filtro.tipoAcordo = '';
      this.filtro.status = 'APROVADO';
      this.filtro.tipoLinhaOrcamento = '';
      this.filtro.marca = '';
      this.filtro.linhaProduto = '';
      this.filtro.familia = '';
      this.filtro.produto = '';
      this.filtro.cliente = '';
      this.justificativa = '';
      this.meuPassoPendente = true;

      if (this.filtro.idCliente) {
        delete this.filtro.idCliente;
      }
      if (this.filtro.idExtensao) {
        delete this.filtro.idExtensao;
      }
      if (this.filtro.idLinhaProduto) {
        delete this.filtro.idLinhaProduto;
      }
      if (this.filtro.idMarca) {
        delete this.filtro.idMarca;
      }
      if (this.filtro.idProduto) {
        delete this.filtro.idProduto;
      }
      if (this.filtro.idTipoLinhaOrcamento) {
        delete this.filtro.idTipoLinhaOrcamento;
      }
    },
    requestVoltarTelaInicial() {
      this.$refs.modal.close();
    },
    requestModalAprovarPassoNegociacao(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalAprovar.open();
      this.itemSelecionado = row;
    },
    requestModalComentarioOpcional(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalComentario.open();
      this.itemSelecionado = row;
    },
    requestModalReprovarApuracaoNegociacao(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalReprovar.open();
      this.itemSelecionado = row;
    },
    requestDownloadEvidenciaReivindicacao(row) {
      const idReivindicacao = row.idReivindicacao;
      this.$emit('APURACAOTABELA_DOWNLOAD', {
        getBasePath: basePath('apuracao', 'reivindicacao'),
        id: idReivindicacao,
      });
    },
    requestAprovarPassosFluxoAcordo() {
      const item = this.itemSelecionado;
      this.reivindicacaoResources.aprovarReivindicacao(
        { idReivindicacao: item.idReivindicacao },
        { observacao: this.justificativa })
        .then(() => {
          this.requestFecharModaisDefault();
          this.requestBuscarApuracoesFilter();
          this.$toast.create(this.$t('message.apuracao_reivindicacao_aprovar'), 'snack', 3E3);
        })
        .catch((err) => {
          this.$error(this, err);
          // this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    requestReprovarPassosReivindicacao() {
      const item = this.itemSelecionado;
      this.reivindicacaoResources.reprovarReivindicacao(
        { idReivindicacao: item.idReivindicacao },
        { observacao: this.justificativa })
        .then(() => {
          this.requestFecharModaisDefault();
          this.requestBuscarApuracoesFilter();
          this.$toast.create(this.$t('message.apuracao_reivindicacao_reprovar'), 'snack', 3E3);
        })
        .catch((err) => {
          this.$error(this, err);
          // this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    requestBuscarApuracoesFilter() {
      this.$emit('APURACAOTABELA_FILTER', this.filtro, this.requestVoltarTelaInicial);
    },
    setTipoInvestimentoOrcamento(hit) {
      this.filtro.idTipoLinhaOrcamento = hit.id;
      this.filtro.tipoLinhaOrcamento = hit.descTipoOrcamento;
    },
    setMarca(hit) {
      this.filtro.idExtensao = hit.id;
      this.filtro.marca = hit.nomExtensao;
    },
    setFamilia(hit) {
      this.filtro.idMarca = hit.id;
      this.filtro.familia = hit.nomExtensao;
    },
    setLinhaProduto(hit) {
      this.filtro.idLinhaProduto = hit.id;
      this.filtro.linhaProduto = hit.nomExtensao;
    },
    setProduto(hit) {
      this.filtro.idProduto = hit.id;
      this.filtro.produto = hit.nomProduto;
    },
    setCliente(hit) {
      this.filtro.idCliente = hit.id;
      this.filtro.cliente = hit.nomCliente;
    },
    setUnidadeNegocio(hit, row) {
      this.dependenciaUnidadeNegocio = {
        idUnidadeNegocio: hit.id,
        nomExtensao: hit.nomExtensao,
        unidadeNegocio: hit.nomExtensao,
      };
      this.updateItemDependency(row, 'dependencias', this.dependenciaUnidadeNegocio);
    },
    clickHandler(pagina) {
      this.indexPagina = pagina - 1;
      this.$emit('DASH_APURACAO_TABELA_PAGINA', this.filtro, pagina);
    },
    refazPaginacao() {
      this.indexPagina = 0;
    },
  },
  mounted() {
    this.filtroCopy = this.filtro;
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/ReivindicacaoTabelaDash.vue?vue&type=script&lang=js&